import { render, staticRenderFns } from "./Activas.vue?vue&type=template&id=5b4f9120&"
import script from "./Activas.vue?vue&type=script&lang=js&"
export * from "./Activas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports